import axios from "axios";

export const API = `${(process.env.REACT_APP_BACKEND_URL || "").replace(/\/$/, "")}/api`;

export const api = axios.create({ baseURL: API });

export const adminToken = {
  get: () => localStorage.getItem("mt_admin_token"),
  set: (t) => localStorage.setItem("mt_admin_token", t),
  clear: () => localStorage.removeItem("mt_admin_token"),
};

export const authHeaders = () => ({
  headers: { Authorization: `Bearer ${adminToken.get()}` },
});

export function formatApiError(e, fallback = "Something went wrong. Please try again.") {
  const detail = e?.response?.data?.detail;
  if (typeof detail === "string") return detail;
  if (Array.isArray(detail)) return detail.map((x) => x?.msg || "").filter(Boolean).join(" ");
  return e?.message || fallback;
}
